type SearchFieldOptionType = {
  id: string
  label: string
  field: 'text' | 'defaultSelect' | 'select' | 'date' | 'filter'
  multiple?: boolean
  enterSearch?: boolean
  options?: Record<string, string> | {value: string; label: string}[]
}

const baseFilter: Record<string, SearchFieldOptionType> = {
  customerInfoFilter: {
    id: 'searchDataField',
    label: '필터',
    field: 'filter',
    multiple: true,
  },
  customerBinaryCheckFilter: {id: 'searchDataFieldBinaryCheck', label: '필터', field: 'filter'},
}

const baseText: Record<string, SearchFieldOptionType> = {
  searchData: {id: 'searchData', label: '검색어', field: 'text'},
  searchKeyword: {id: 'searchKeyword', label: '검색어', field: 'text'},
  customerName: {id: 'customerName', label: '수용가이름', field: 'filter'},
  customerNumber: {id: 'customerNumber', label: '수용가번호', field: 'filter'},
  serialNumber: {id: 'serialNumber', label: '단말기 일련번호', field: 'filter'},
  address: {id: 'address', label: '주소', field: 'filter'},
  managerName: {id: 'managerName', label: '담당자', field: 'filter'},
  installerName: {id: 'installerName', label: '설치자', field: 'filter'},
  memo: {id: 'memo', label: '메모', field: 'filter'},
}

const baseSelect: Record<string, SearchFieldOptionType> = {
  deviceStatus: {id: 'deviceStatus', label: '단말기 통신 상태', field: 'defaultSelect'},
  batteryStatus: {id: 'batteryStatus', label: '배터리 상태', field: 'defaultSelect'},
  efosStatus: {id: 'efosStatus', label: '계량기 통신 상태', field: 'defaultSelect'},
  deviceType: {id: 'deviceType', label: '단말기 타입', field: 'defaultSelect'},
  recognizedType: {id: 'recognizedType', label: '계량기 타입', field: 'defaultSelect'},
  compareType: {id: 'compareType', label: '이미지 검증 상태', field: 'defaultSelect'},
  isRevised: {id: 'isRevised', label: '이미지 보정', field: 'select'},
  signalStrength: {id: 'signalStrength', label: '신호 세기', field: 'select'},
  temperature: {id: 'temperature', label: '온도', field: 'select'},

  processStatus: {
    id: 'processStatus',
    label: '이미지 인식상태(다중선택)',
    field: 'select',
    multiple: true,
  },
  assignStatus: {id: 'assignStatus', label: '할당상태', field: 'select'},
  customerStatus: {id: 'customerStatus', label: '설치가능 여부', field: 'select'},
  asStatus: {id: 'customerStatus', label: '수용가 상태', field: 'select'},
  diameters: {id: 'diameters', label: '구경(다중선택)', field: 'select', multiple: true},
  serverCycle: {id: 'serverCycle', label: '통신주기(다중선택)', field: 'select', multiple: true},
}

const baseDate: Record<string, SearchFieldOptionType> = {
  startDate: {id: 'startDate', label: '설치일 (시작)', field: 'date'},
  endDate: {id: 'endDate', label: '설치일 (종료)', field: 'date'},
  date: {id: 'date', label: '날짜', field: 'date'},
  findStartDate: {id: 'startDate', label: '시작 날짜', field: 'date'},
  findEndDate: {id: 'endDate', label: '마지막 날짜', field: 'date'},
  findIssueStartDate: {id: 'startIssueDate', label: '이슈 조회 시작일', field: 'date'},
  findIssueEndDate: {id: 'endIssueDate', label: '이슈 조회 종료일', field: 'date'},
}

export const customerInfoSearchOption: SearchFieldOptionType[] = [
  baseFilter.customerInfoFilter,
  //text
  baseText.searchData,

  //select
  baseSelect.deviceStatus,
  baseSelect.batteryStatus,
  baseSelect.efosStatus,
  baseSelect.deviceType,
  baseSelect.recognizedType,
  baseSelect.isRevised,
  baseSelect.signalStrength,
  baseSelect.temperature,
  baseSelect.processStatus,
  baseSelect.asStatus, // 할당(allocation)에 있는 customerStatus랑 혼동 주의
  baseSelect.diameters,
  /* 통신주기는 사업소별로만 노출한다. CustomerInfo 에서 useServerCycleSetting 으로 걸러낸다. */
  baseSelect.serverCycle,
  //date
  baseDate.startDate,
  baseDate.endDate,
]

export const customerBinaryCheckSearchOption: SearchFieldOptionType[] = [
  baseFilter.customerBinaryCheckFilter,
  //text
  baseText.searchData,
  //select
  baseSelect.deviceStatus,
  baseSelect.efosStatus,
  baseSelect.recognizedType,
  baseSelect.compareType,
  baseSelect.asStatus, // 할당(allocation)에 있는 customerStatus랑 혼동 주의
  //date
  baseDate.findStartDate,
  baseDate.findEndDate,
]

export const customerFlaggedReviewSearchOption: SearchFieldOptionType[] = [
  // baseFilter.customerInfoFilter, // searchTarget enum 값 미확정으로 보류, 통합검색(searchKeyword)만 사용
  //text
  baseText.searchKeyword,
  //select
  // 단말기 통신/배터리/계량기 통신 상태, 단말기 타입은 상단 이슈 칩과 기능이 겹쳐 제거
  baseSelect.recognizedType,
  baseSelect.isRevised,
  baseSelect.signalStrength,
  baseSelect.temperature,
  baseSelect.asStatus, // 할당(allocation)에 있는 customerStatus랑 혼동 주의
  baseSelect.diameters,
  //date
  baseDate.findIssueStartDate,
  baseDate.findIssueEndDate,
]
